import React from "react";
import { Box, Stack } from "@mui/material";
import { useStyles } from "./FmCarbonFootprintTable.style";
import { FmFertigationRate } from "./FmFertigationRate";
import { CarbonFootprintData } from "../../types";

interface FmCarbonFootprintTableProps extends CarbonFootprintData {
    isLastChild?: boolean;
}

export const FmCarbonTableContentRow = (props: FmCarbonFootprintTableProps) => {
    const { regularColumnText, headerTextWidthPadding, borderBottomContentRow } = useStyles();

    return (
        <Stack direction='row' className={props.isLastChild ? "" : borderBottomContentRow} justifyContent='space-between'>
            <Box className={regularColumnText} sx={{ width: "20%", padding: "32px 0" }}>
                {props.environmentalParameter}
                <span style={{ opacity: 0.5, marginLeft: "1rem" }}>{props.measureUnit}</span>
            </Box>

            <Box
                className={headerTextWidthPadding}
                sx={{
                    paddingTop: "32px",
                    paddingBottom: "32px",
                    backgroundColor: "#e4f5ec",
                    color: "#248B5B",
                }}
            >
                <span>{props.multicoteTechnology ? Number(props.multicoteTechnology).toExponential(2) : props.multicoteTechnology?.toExponential(2)}</span>
            </Box>

            <Box
                className={headerTextWidthPadding}
                sx={{
                    paddingTop: "32px",
                    paddingBottom: "32px",
                    backgroundColor: "#F3F3F3",
                    color: "#000",
                }}
            >
                <span>{props.traditional ? Number(props.traditional).toExponential(2) : props.traditional?.toExponential(2)}</span>
            </Box>

            <Box sx={{ width: "30%", paddingTop: "32px" }}>
                <FmFertigationRate rate={props.fertigationRating} />
            </Box>
        </Stack>
    );
};
